import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";
import { setColor, setFont } from "../../../../../assets/styles/styles";
import Title from "../../../components/Title";
import Body from "../../../layout/Body";
import { formatDateTimeWithTimeZone } from "../../../../../utils/generalUtils";
import LoadingIcon from "../../../../../components/common/loading/LoadingIcon";
import { getRoomSettingsById, updateRoomSettingsById } from "../../rooms/api/roomController";
import { ReactComponent as ChevronIcon } from "../../../../../assets/images/icons/Chevron.svg";
import Typography from "../../../../../components/common/text/Typography";
import { default as Button } from "../../../../../components/common/button/Button";
import { DEFAULT_QUERY_OPTIONS } from "../../../../../constants";
import ToggleSwitch from "../../../../../components/common/switchToggle/ToggleSwitch";
import Modal from "../../../components/Modal";
import JsonViewerModal from "./JsonViewerModal";
import { ReactComponent as LinkoutIcon } from "../../../../../assets/images/icons/linkout.svg";
import { ReactComponent as Checkmark } from "../../../../../assets/images/icons/Checkmark.svg";
import Banner from "../../../../../components/layout/ui/Banner";
import pinkCheckmark from "../../../../../assets/images/icons/pink-checkmark.png";
import { ReactComponent as Cross } from "../../../../../assets/images/icons/Cross.svg";
import { getAllKeybinds } from "../../../../../api/ClientsTagController";

const RoomSettingsPage = ({ roomId, setRoomSettingsId, setStepNext }) => {
    const [openModal, setOpenModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [voiceChatEnabled, setVoiceChatEnabled] = useState(false);
    const [doFormsExist, setDoFormsExist] = useState(false);
    const [leaderboardsEnabled, setLeaderboardsEnabled] = useState(false);
    const [spotifyEnabled, setSpotifyEnabled] = useState(false);
    const [ecommerceEnabled, setEcommerceEnabled] = useState(false);
    const [settingsMenuEnabled, setSettingsMenuEnabled] = useState(false);
    const [canReturnToNavMenuEnabled, setCanReturnToNavMenuEnabled] = useState(false);
    const [privacy, setPrivacy] = useState("public");
    const [currentField, setCurrentField] = useState(null);
    const [currentFieldLabel, setCurrentFieldLabel] = useState(null);
    const [isJsonEditorOpen, setIsJsonEditorOpen] = useState(false);
    const [jsonEditorValue, setJsonEditorValue] = useState("");
    const [spotifyTrackVal, setSpotifyTrackVal] = useState("");
    const [broadcastIdVal, setBroadcastIdVal] = useState("");
    const [showUpdateButtonSpotify, setShowUpdateButtonSpotify] = useState(false);
    const [showUpdateButtonBroad, setShowUpdateButtonBroad] = useState(false);
    const [showUpdateKeybind, setShowUpdateKeybind] = useState(false);
    const [textChatEnabled, setTextChatEnabled] = useState(false);
    const [showEmoteWheel, setShowEmoteWheel] = useState(false);
    const [showFriends, setShowFriends] = useState(false);
    const [keyOptions, setKeyOptions] = useState([]);
    const [valueOptions, setValueOptions] = useState([]);

    const [tooglesLdr, setTooglesLdr] = useState({
        voiceChatEnabled: false,
        leaderboardsEnabled: false,
        spotifyEnabled: false,
        ecommerceEnabled: false,
        settingsMenuEnabled: false,
        canReturnToNavMenuEnabled: false,
        textChatEnabled: false,
        showEmoteWheel: false,
        showFriends: false,
    });
    const [tooglesErr, setTooglesErr] = useState({
        voiceChatEnabled: "",
        leaderboardsEnabled: "",
        spotifyEnabled: "",
        ecommerceEnabled: "",
        settingsMenuEnabled: "",
        canReturnToNavMenuEnabled: "",
        textChatEnabled: "",
        showEmoteWheel: "",
        showFriends: "",
    });

    const [tooglesSucs, setTooglesSucs] = useState({
        voiceChatEnabled: "",
        leaderboardsEnabled: "",
        spotifyEnabled: "",
        ecommerceEnabled: "",
        settingsMenuEnabled: "",
        canReturnToNavMenuEnabled: "",
        textChatEnabled: "",
        showEmoteWheel: "",
        showFriends: "",
    });

    const { data: keybindsData, isLoading: roomPresetsLoading } = useQuery(
        ["keybindsOptions"], // Query key, add params if needed
        () => getAllKeybinds(), // Query function
        {
            ...DEFAULT_QUERY_OPTIONS(),
        }
    );

    const [newKey, setNewKey] = useState("");
    const [newValue, setNewValue] = useState("");
    const [presetKeybinds, setPresetKeybinds] = useState({});

    const {
        data: roomSettingData,
        error: roomError,
        isLoading,
        refetch,
    } = useQuery(["roomSettingInfo", roomId], () => getRoomSettingsById(roomId), {
        enabled: !!roomId,
        ...DEFAULT_QUERY_OPTIONS(),
    });

    const openJsonEditor = (fieldName, label, value) => {
        setCurrentField(fieldName);
        setCurrentFieldLabel(label);
        setJsonEditorValue(JSON.stringify(value, null, 2));
        setIsJsonEditorOpen(true);
    };

    const handleJsonSave = async (e, field) => {
        const respUpdateSettings = await updateRoomSettingsById(roomId, {
            [field]: e,
        });

        if (respUpdateSettings.status === 200) {
            setTooglesErr({ ...tooglesErr, [field]: "" });
            setErrorMessage(false);
            setSuccessMessage(true);
        } else {
            setErrorMessage(true);
            setSuccessMessage(false);
        }
        refetch();
    };

    useEffect(() => {
        setKeyOptions(keybindsData?.data?.keyOptions || []);
        setValueOptions(keybindsData?.data?.valueOptions || []);

        console.log("Key Options:", keybindsData?.data?.keyOptions);
        console.log("Value Options:", keybindsData?.data?.valueOptions);
    }, [keybindsData]);

    useEffect(() => {
        if (errorMessage || successMessage) {
            const timer = setTimeout(() => {
                setErrorMessage("");
                setSuccessMessage("");
                setTooglesErr({
                    voiceChatEnabled: "",
                    leaderboardsEnabled: "",
                    spotifyEnabled: "",
                    ecommerceEnabled: "",
                    settingsMenuEnabled: "",
                    canReturnToNavMenuEnabled: "",
                    textChatEnabled: "",
                    showEmoteWheel: "",
                    showFriends: "",
                });
                setTooglesSucs({
                    voiceChatEnabled: "",
                    leaderboardsEnabled: "",
                    spotifyEnabled: "",
                    ecommerceEnabled: "",
                    settingsMenuEnabled: "",
                    canReturnToNavMenuEnabled: "",
                    textChatEnabled: "",
                    showEmoteWheel: "",
                    showFriends: "",
                });
                setVoiceChatEnabled(roomSettingData.voiceChatEnabled);
                setDoFormsExist(roomSettingData.doFormsExist);
                setLeaderboardsEnabled(roomSettingData.leaderboardsEnabled);
                setSpotifyEnabled(roomSettingData.spotifyEnabled);
                setEcommerceEnabled(roomSettingData.ecommerceEnabled);
                setSettingsMenuEnabled(roomSettingData.settingsMenuEnabled);
                setCanReturnToNavMenuEnabled(roomSettingData.canReturnToNavMenuEnabled);
                setPrivacy(roomSettingData.privacy);
                setJsonEditorValue(JSON.stringify(roomSettingData.products, null, 2));
                setSpotifyTrackVal(roomSettingData.spotifyTrack);
                setBroadcastIdVal(roomSettingData.broadcastId);
                setShowUpdateButtonSpotify(false);
                setShowUpdateButtonBroad(false);
                setTextChatEnabled(roomSettingData.textChatEnabled);
                setShowEmoteWheel(roomSettingData.showEmoteWheel);
                setShowFriends(roomSettingData.showFriends);
                setPresetKeybinds(roomSettingData.keybindsPreset);
            }, 3000);
            return () => clearTimeout(timer);
        }
        refetch();
    }, [errorMessage, successMessage, tooglesErr, tooglesSucs]);

    useEffect(() => {
        if (roomSettingData) {
            setRoomSettingsId(roomSettingData.roomSettingsId);
            setVoiceChatEnabled(roomSettingData.voiceChatEnabled);
            setDoFormsExist(roomSettingData.doFormsExist);
            setLeaderboardsEnabled(roomSettingData.leaderboardsEnabled);
            setSpotifyEnabled(roomSettingData.spotifyEnabled);
            setEcommerceEnabled(roomSettingData.ecommerceEnabled);
            setSettingsMenuEnabled(roomSettingData.settingsMenuEnabled);
            setCanReturnToNavMenuEnabled(roomSettingData.canReturnToNavMenuEnabled);
            setPrivacy(roomSettingData.privacy);
            setJsonEditorValue(JSON.stringify(roomSettingData.products, null, 2));
            setSpotifyTrackVal(roomSettingData.spotifyTrack);
            setBroadcastIdVal(roomSettingData.broadcastId);
            setTextChatEnabled(roomSettingData.textChatEnabled);
            setShowEmoteWheel(roomSettingData.showEmoteWheel);
            setShowFriends(roomSettingData.showFriends);
            setPresetKeybinds(roomSettingData.keybindsPreset);
        }
    }, [roomSettingData]);

    const handleUpdateSettingsToogles = async (e, field) => {
        setTooglesLdr({ ...tooglesLdr, [field]: true });
        let respUpdateSettings = "";
        if (field !== "privacy") {
            respUpdateSettings = await updateRoomSettingsById(roomId, {
                [field]: e,
            });
        }
        if (field === "privacy") {
            respUpdateSettings = await updateRoomSettingsById(roomId, {
                [field]: e ? "public" : "private",
            });
        }
        if (respUpdateSettings.status === 200) {
            setTooglesErr({ ...tooglesErr, [field]: "" });
            setErrorMessage(false);
            setSuccessMessage(true);
            setTooglesSucs({
                ...tooglesSucs,
                [field]: `Success`,
            });
            setTooglesLdr({ ...tooglesLdr, [field]: false });
        } else {
            setErrorMessage(true);
            setSuccessMessage(false);
            setTooglesErr({
                ...tooglesErr,
                [field]: `Failed`,
            });
            setTooglesSucs({ ...tooglesSucs, [field]: "" });
            setTooglesLdr({ ...tooglesLdr, [field]: false });
        }
    };

    const handleContentClick = (e, field) => {
        if (field === "broadcastId") {
            setBroadcastIdVal(e.target.value);
            if (e.target.value === roomSettingData.broadcastId) {
                setShowUpdateButtonBroad(false);
            } else {
                setShowUpdateButtonBroad(true);
            }
        }
        if (field === "spotifyTrack") {
            setSpotifyTrackVal(e.target.value);
            if (e.target.value === roomSettingData.spotifyTrack) {
                setShowUpdateButtonSpotify(false);
            } else {
                setShowUpdateButtonSpotify(true);
            }
        }
    };

    const handleCheckmarkClick = async (field, value) => {
        setTooglesLdr({ ...tooglesLdr, [field]: true });
        let respUpdateSettings = "";

        if (field === "spotifyTrack") {
            respUpdateSettings = await updateRoomSettingsById(roomId, {
                [field]: value,
            });
        }
        if (field === "broadcastId") {
            respUpdateSettings = await updateRoomSettingsById(roomId, {
                [field]: value,
            });
        }

        if (field === "keybindsPreset") {
            respUpdateSettings = await updateRoomSettingsById(roomId, {
                [field]: value,
            });
        }

        if (respUpdateSettings.status === 200) {
            setErrorMessage(false);
            setSuccessMessage(true);
            refetch();
            setShowUpdateButtonSpotify(false);
            setShowUpdateButtonBroad(false);
        } else {
            setErrorMessage(true);
            setSuccessMessage(false);
            refetch();
            setShowUpdateButtonSpotify(false);
            setShowUpdateButtonBroad(false);
        }
    };

    const handleCloseClick = (field, value) => {
        if (field === "broadcastId") {
            setBroadcastIdVal(value);
        }
        if (field === "spotifyTrack") {
            setSpotifyTrackVal(value);
        }
        if (field === "keybindsPreset") {
            setPresetKeybinds(value);
        }
        setShowUpdateButtonBroad(false);
        setShowUpdateButtonSpotify(false);
        setShowUpdateKeybind(false);
    };

    const usedKeys = Object.keys(presetKeybinds);
    const usedValues = Object.values(presetKeybinds);

    const handleAddKeybind = () => {
        if (newKey && newValue && !usedKeys.includes(newKey) && !usedValues.includes(newValue)) {
            setPresetKeybinds((prev) => {
                const updatedKeybinds = {
                    ...prev,
                    [newKey]: newValue,
                };
                if (JSON.stringify(updatedKeybinds) !== JSON.stringify(roomSettingData.keybindsPreset)) {
                    setShowUpdateKeybind(true);
                }
                return updatedKeybinds;
            });
            setNewKey("");
            setNewValue("");
        }
    };

    const handleRemoveKeybind = (keyToRemove) => {
        setPresetKeybinds((prev) => {
            const { [keyToRemove]: _, ...remainingKeybinds } = prev;
            if (JSON.stringify(remainingKeybinds) !== JSON.stringify(roomSettingData.keybindsPreset)) {
                setShowUpdateKeybind(true);
            } else {
                setShowUpdateKeybind(false);
            }
            return remainingKeybinds;
        });
    };

    const clearAllKeybinds = () => {
        setPresetKeybinds({});
        setNewKey("");
        setNewValue("");
        if (JSON.stringify(roomSettingData.keybindsPreset) !== JSON.stringify({})) {
            setShowUpdateKeybind(true);
        } else {
            setShowUpdateKeybind(false);
        }
    };

    return (
        <>
            {successMessage && (
                <Banner
                    width={"100%"}
                    zIndex="1000"
                    message={`Data updated successfully`}
                    type={"SUCCESS"}
                    openBanner={!!successMessage}
                    setOpenBanner={setSuccessMessage}
                    topDisplay
                    showCloseButton
                    gameScreen={false}
                    top={"0px"}
                    left={"0"}
                />
            )}

            {errorMessage && (
                <Banner
                    width={"100%"}
                    zIndex="1000"
                    message={`Error updating data`}
                    type={"ERROR"}
                    openBanner={!!errorMessage}
                    setOpenBanner={setErrorMessage}
                    topDisplay
                    showCloseButton
                    gameScreen={false}
                    top={"0px"}
                    left={"0"}
                />
            )}

            {roomSettingData && (
                <>
                    <CardTable>
                        <Row>
                            <TableColumn>
                                <Typography variant="ConsoleDescription">
                                    ROOM ID:&nbsp;
                                    {roomId}
                                </Typography>
                                <Typography variant="ConsoleDescription">
                                    ROOM SETTING ID:&nbsp;
                                    {roomSettingData.roomSettingsId}
                                </Typography>
                            </TableColumn>
                        </Row>
                    </CardTable>

                    <Table>
                        <CardTable>
                            <Tag>Switches</Tag>
                            <Row marginBottom>
                                <Column>
                                    <Label>Enable Voice Chat</Label>
                                    <ToggleSwitch
                                        value={voiceChatEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "voiceChatEnabled")}
                                    />
                                    {tooglesLdr.voiceChatEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.voiceChatEnabled && (
                                        <MessageDesc type="error">{tooglesErr.voiceChatEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.voiceChatEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.voiceChatEnabled}</MessageDesc>
                                    )}
                                </Column>
                                <Column>
                                    <Label>Is Room Public?</Label>
                                    <ToggleSwitch
                                        value={privacy === "public"}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "privacy")}
                                    />
                                    {tooglesLdr.privacy && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.privacy && <MessageDesc type="error">{tooglesErr.privacy}</MessageDesc>}
                                    {tooglesSucs.privacy && (
                                        <MessageDesc type="success">{tooglesSucs.privacy}</MessageDesc>
                                    )}
                                </Column>
                                <Column>
                                    <Label>Show Leaderboards</Label>
                                    <ToggleSwitch
                                        value={leaderboardsEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "leaderboardsEnabled")}
                                    />
                                    {tooglesLdr.leaderboardsEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.leaderboardsEnabled && (
                                        <MessageDesc type="error">{tooglesErr.leaderboardsEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.leaderboardsEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.leaderboardsEnabled}</MessageDesc>
                                    )}
                                </Column>
                                <Column>
                                    <Label>Spotify Integration</Label>
                                    <ToggleSwitch
                                        value={spotifyEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "spotifyEnabled")}
                                    />
                                    {tooglesLdr.spotifyEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.spotifyEnabled && (
                                        <MessageDesc type="error">{tooglesErr.spotifyEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.spotifyEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.spotifyEnabled}</MessageDesc>
                                    )}
                                </Column>
                            </Row>
                            <Row marginBottom>
                                <Column>
                                    <Label>Enable E-commerce Features</Label>
                                    <ToggleSwitch
                                        value={ecommerceEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "ecommerceEnabled")}
                                    />
                                    {tooglesLdr.ecommerceEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.ecommerceEnabled && (
                                        <MessageDesc type="error">{tooglesErr.ecommerceEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.ecommerceEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.ecommerceEnabled}</MessageDesc>
                                    )}
                                </Column>
                                <Column>
                                    <Label>Show Settings Menu</Label>
                                    <ToggleSwitch
                                        value={settingsMenuEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "settingsMenuEnabled")}
                                    />
                                    {tooglesLdr.settingsMenuEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.settingsMenuEnabled && (
                                        <MessageDesc type="error">{tooglesErr.settingsMenuEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.settingsMenuEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.settingsMenuEnabled}</MessageDesc>
                                    )}
                                </Column>
                                <Column>
                                    <Label>Can Return to Navigation Menu?</Label>
                                    <ToggleSwitch
                                        value={canReturnToNavMenuEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "canReturnToNavMenuEnabled")}
                                    />
                                    {tooglesLdr.canReturnToNavMenuEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.canReturnToNavMenuEnabled && (
                                        <MessageDesc type="error">{tooglesErr.canReturnToNavMenuEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.canReturnToNavMenuEnabled && (
                                        <MessageDesc type="success">
                                            {tooglesSucs.canReturnToNavMenuEnabled}
                                        </MessageDesc>
                                    )}
                                </Column>

                                <Column>
                                    <Label>Text Chat Enabled</Label>
                                    <ToggleSwitch
                                        value={textChatEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "textChatEnabled")}
                                    />
                                    {tooglesLdr.textChatEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.textChatEnabled && (
                                        <MessageDesc type="error">{tooglesErr.textChatEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.textChatEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.textChatEnabled}</MessageDesc>
                                    )}
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <Label>Show Emote Wheel</Label>
                                    <ToggleSwitch
                                        value={showEmoteWheel}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "showEmoteWheel")}
                                    />
                                    {tooglesLdr.showEmoteWheel && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.showEmoteWheel && (
                                        <MessageDesc type="error">{tooglesErr.showEmoteWheel}</MessageDesc>
                                    )}
                                    {tooglesSucs.showEmoteWheel && (
                                        <MessageDesc type="success">{tooglesSucs.showEmoteWheel}</MessageDesc>
                                    )}
                                </Column>
                                <Column>
                                    <Label>Show Friends</Label>
                                    <ToggleSwitch
                                        value={showFriends}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "showFriends")}
                                    />
                                    {tooglesLdr.showFriends && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.showFriends && (
                                        <MessageDesc type="error">{tooglesErr.showFriends}</MessageDesc>
                                    )}
                                    {tooglesSucs.showFriends && (
                                        <MessageDesc type="success">{tooglesSucs.showFriends}</MessageDesc>
                                    )}
                                </Column>
                                <Column>
                                    <Label>Are Forms Available?</Label>
                                    <ToggleSwitch value={doFormsExist} disabled />
                                </Column>
                                <Column>{""}</Column>
                            </Row>
                        </CardTable>
                        <CardTable>
                            <Tag>Content Fields</Tag>
                            <Row marginBottom>
                                <Column>
                                    <Label>Chat Channel ID</Label>
                                    <InputBox
                                        type="text"
                                        name="chatChannelId"
                                        disabled
                                        value={roomSettingData.chatChannelId}
                                    />
                                </Column>
                                <Column>
                                    <Label>Spotify Track</Label>
                                    <InputBox
                                        type="text"
                                        name="spotifyTrack"
                                        value={spotifyTrackVal}
                                        onChange={(e) => handleContentClick(e, "spotifyTrack")}
                                    />
                                    <Row>
                                        {showUpdateButtonSpotify && (
                                            <>
                                                <StyledCheckmark
                                                    onClick={() =>
                                                        handleCheckmarkClick("spotifyTrack", spotifyTrackVal)
                                                    }
                                                />
                                                <StyledCloseIcon
                                                    onClick={() =>
                                                        spotifyTrackVal &&
                                                        handleCloseClick("spotifyTrack", roomSettingData.spotifyTrack)
                                                    }
                                                />
                                            </>
                                        )}
                                    </Row>
                                </Column>

                                <Column>
                                    <Label>Broadcast ID</Label>
                                    <InputBox
                                        type="text"
                                        name="broadcastId"
                                        value={broadcastIdVal}
                                        onChange={(e) => handleContentClick(e, "broadcastId")}
                                    />
                                    <Row>
                                        {showUpdateButtonBroad && (
                                            <>
                                                <StyledCheckmark
                                                    onClick={() => handleCheckmarkClick("broadcastId", broadcastIdVal)}
                                                />
                                                <StyledCloseIcon
                                                    onClick={() =>
                                                        broadcastIdVal &&
                                                        handleCloseClick("broadcastId", roomSettingData.broadcastId)
                                                    }
                                                />
                                            </>
                                        )}
                                    </Row>
                                </Column>
                            </Row>
                        </CardTable>

                        <CardTable>
                            <Tag>Lists</Tag>
                            <Row marginBottom>
                                {[
                                    {
                                        name: "passwords",
                                        label: "Passwords",
                                    },
                                    {
                                        name: "products",
                                        label: "Products",
                                    },
                                    {
                                        name: "videoPayload",
                                        label: "Video Payload",
                                    },
                                ].map(({ name, label }) => (
                                    <Column key={name}>
                                        <Label>{label}</Label>
                                        <InputBox
                                            type="text"
                                            name={name}
                                            value={JSON.stringify(roomSettingData[name] || {})}
                                            onClick={() => openJsonEditor(name, label, roomSettingData[name])}
                                        />
                                    </Column>
                                ))}
                            </Row>
                            {/* <Row marginBottom>
                                {[
                                    { name: "frames", label: "Frames" },
                                    {
                                        name: "forms",
                                        label: "Forms/Surveys",
                                    },
                                    {
                                        name: "subroomRoomIds",
                                        label: "Subroom Rooms",
                                    },
                                ].map(({ name, label }) => (
                                    <Column key={name}>
                                        <Label>
                                            {label}
                                            {name !== "frames" && <StyledLinkoutIcon onClick={handleLinkOuts(name)} />}
                                        </Label>
                                        <InputBox
                                            type="text"
                                            name={name}
                                            value={JSON.stringify(roomSettingData[name] || {})}
                                            onClick={() => openJsonEditor(name, label, roomSettingData[name])}
                                        />
                                    </Column>
                                ))}
                            </Row> */}
                        </CardTable>
                        <CardTable>
                            <Tag>Data Objects</Tag>
                            <Row marginBottom>
                                {[
                                    {
                                        name: "linkoutPayload",
                                        label: "External Links",
                                    },
                                    {
                                        name: "panelPromptText",
                                        label: "Panel Prompt Instructions",
                                    },
                                    {
                                        name: "coordinates",
                                        label: "Location Coordinates",
                                    },
                                    {
                                        name: "dynamicLinkouts",
                                        label: "Dynamic Linkouts",
                                    },
                                ].map(({ name, label }) => (
                                    <Column key={name}>
                                        <Label>{label}</Label>
                                        <InputBox
                                            type="text"
                                            name={name}
                                            value={JSON.stringify(roomSettingData[name] || {})}
                                            onClick={() => openJsonEditor(name, label, roomSettingData[name])}
                                        />
                                    </Column>
                                ))}
                            </Row>
                        </CardTable>
                        <CardTable>
                            <Tag>Add Keybinds</Tag>
                            <TableRow>
                                <TableColumn>
                                    <Label>Preset Key binds</Label>
                                    <KeybindContainer>
                                        <SelectBox value={newKey} onChange={(e) => setNewKey(e.target.value)}>
                                            <option value="">Select Key</option>
                                            {keyOptions
                                                .filter((key) => !usedKeys.includes(key))
                                                .map((key) => (
                                                    <option key={key} value={key}>
                                                        {key}
                                                    </option>
                                                ))}
                                        </SelectBox>
                                        <SelectBox
                                            value={newValue}
                                            onChange={(e) => {
                                                setNewValue(e.target.value);
                                            }}
                                        >
                                            <option value="">Select Action</option>
                                            {valueOptions
                                                .filter((val) => !usedValues.includes(val))
                                                .map((val) => (
                                                    <option key={val} value={val}>
                                                        {val}
                                                    </option>
                                                ))}
                                        </SelectBox>
                                        <Button
                                            type="button"
                                            variant={"SmallButton"}
                                            label={"+"}
                                            onClick={handleAddKeybind}
                                            disabled={
                                                !newKey ||
                                                !newValue ||
                                                usedKeys.includes(newKey) ||
                                                Object.keys(presetKeybinds).length >= 8
                                            }
                                        />
                                    </KeybindContainer>
                                    <KeybindList>
                                        {Object.keys(presetKeybinds).length >= 8 && (
                                            <Typography
                                                variant="pWhite"
                                                margin={"0"}
                                                fontSize={"18px"}
                                                color={`${setColor.redLightWarning}`}
                                                align={"left"}
                                                letterSpacing={"0px"}
                                            >
                                                You can only add up to 8 keybinds.
                                            </Typography>
                                        )}
                                        {Object.entries(presetKeybinds).map(([key, val]) => (
                                            <KeybindItem key={key}>
                                                {key} → {val}
                                                <Button
                                                    variant={"SmallButton"}
                                                    margin={"0 0 0 10px"}
                                                    label="-"
                                                    onClick={() => handleRemoveKeybind(key)}
                                                />
                                            </KeybindItem>
                                        ))}
                                    </KeybindList>
                                    <Button
                                        type="button"
                                        variant={"SmallButton"}
                                        margin={"10px 0 0 0"}
                                        label="Clear All"
                                        onClick={() => clearAllKeybinds()}
                                    />
                                    {showUpdateKeybind && (
                                        <>
                                            <StyledCheckmark
                                                onClick={() => handleCheckmarkClick("keybindsPreset", presetKeybinds)}
                                            />
                                            <StyledCloseIcon
                                                onClick={() =>
                                                    handleCloseClick("keybindsPreset", roomSettingData.keybindsPreset)
                                                }
                                            />
                                        </>
                                    )}
                                </TableColumn>
                            </TableRow>
                        </CardTable>
                        <Row>
                            <Button
                                margin={"2rem 0rem"}
                                variant={"PinkButton"}
                                buttonWidth={"100%"}
                                label={"Update/Review Room Settings → Proceed to Step 3"}
                                onClick={() => setStepNext("step3")}
                            />
                        </Row>
                        {isJsonEditorOpen && (
                            <Modal
                                isOpen={isJsonEditorOpen}
                                setIsOpen={setIsJsonEditorOpen}
                                children={
                                    <JsonViewerModal
                                        jsonEditorValue={jsonEditorValue}
                                        handleJsonSave={handleJsonSave}
                                        fieldName={currentField}
                                        label={currentFieldLabel}
                                        closeModal={() => setIsJsonEditorOpen(false)}
                                    />
                                }
                            />
                        )}
                    </Table>
                </>
            )}
        </>
    );
};

export default RoomSettingsPage;

const JSONEditorModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
`;

const UserConsoleText = styled.h1`
    font-family: "Barlow Condensed", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 1.6px;
    text-transform: uppercase;
    width: fit-content;
    color: ${setColor.accent4};
    position: relative;
    cursor: pointer;
`;

const StyledIconPrev = styled(ChevronIcon)`
    transition: transform 0.3s;
    transform: rotate(180deg);
    border-radius: 5px !important;
    margin-top: 12px !important;
    transform: rotate(90deg) !important;
`;
const Tag = styled.div`
    position: absolute;
    top: 0px;
    right: 0px;
    background-color: ${setColor.greenSuccess};
    color: white;
    border-radius: 5px;
    font-weight: 700;
    padding: 5px 10px;
    font-size: 14px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const CardTable = styled.div`
    position: relative;
    height: auto;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    color: ${setColor.inputText};
    // background: ${setColor.onHoverTextcolor2};
    border-bottom: 1px solid ${setColor.accent4};
    border-radius: 5px;
    margin-top: 1rem;
`;

const TableColumn = styled.div`
    flex: 1;
    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const TableColumnButton = styled.div`
    justify-content: flex-end;
    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const Table = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    // padding: 20px 20px 20px 20px;
    color: ${setColor.inputText};
`;

const Row = styled.div`
    display: flex;
    margin: ${(props) => (props.marginBottom ? "1rem 0rem" : "0rem orem")};
`;

const RowMain = styled.div`
    display: flex;
    margin-bottom: 1.5rem;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 600;
    border-radius: 5px;
    width: 15%;
    padding: 5px;
    border-bottom: 1px solid ${setColor.accent4};
    border-top: 1px solid ${setColor.accent4};
`;

const Label = styled.div`
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
`;
const InputBox = styled.input`
    padding: 10px;
    flex: 1;
    border: 1px solid ${setColor.grey1};
    border-radius: 5px;
    color: ${setColor.inputText};
    width: 90%;
    background-color: transparent;
    margin-bottom: ${(props) => (props.errorMessage ? "1rem" : "0rem")};
    &:disabled {
        background-color: ${setColor.grey1};
    }
`;

const Column = styled.div`
    margin-top: ${(props) => (props.errorMessage ? "1rem" : "0")};
    flex: ${(props) => (props.small ? "0.5" : "2")};
    width: ${(props) => (props.small ? "5%" : "95%")};
    @media (max-width: 768px) {
        flex: ${(props) => (props.small ? "1" : "2")};
    }
`;
const StyledLinkoutIcon = styled(LinkoutIcon)`
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-left: 10px;
    margin-bottom: -5px;
    fill: ${setColor.accent4};
`;

const LoadingDiv = styled.div`
    display: flex;
    margin-left: 5rem;
    margin-top: -1rem;
`;

const MessageDesc = styled.div`
    display: flex;
    margin-left: 5rem;
    margin-top: -1.5rem;
    color: ${(props) => (props.type === "success" ? setColor.successColor : setColor.errorColor)};
`;

const StyledCheckmark = styled(Checkmark)`
    right: 15px;
    height: 20px;
    cursor: pointer;
    margin-top: 10px;
    &:hover {
        #Union {
            fill: ${setColor.greenLight};
        }
    }
`;

const StyledCloseIcon = styled(Cross)`
    border-radius: 5px !important;
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-top: 10px;
    right: 10px;
    &:hover {
        #Union {
            fill: ${setColor.lightPink};
        }
    }
`;

const TableRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
`;

const KeybindContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 10px;
`;

const SelectBox = styled.select`
    padding: 10px 12px;
    border: 1px solid ${setColor.grey1};
    border-radius: 5px;
    color: ${setColor.inputText};
    background-color: ${setColor.inputBgColor};
    font-family: "Barlow-Regular", Helvetica;
    font-size: 14px;
    width: 180px;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23FBFCFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 16px;
    padding-right: 36px;

    &:focus {
        outline: none;
        border-color: ${setColor.accent4};
        box-shadow: 0 0 0 2px ${setColor.purpleDark};
    }

    &:hover {
        border-color: ${setColor.accent4};
    }

    option {
        background-color: ${setColor.solidDarkPurpleBackground};
        color: ${setColor.inputText};
        padding: 12px;
        font-family: "Barlow-Regular", Helvetica;
        font-size: 14px;
    }

    option:hover,
    option:focus,
    option:checked {
        background-color: ${setColor.accent4};
        color: ${setColor.black};
    }
`;

const KeybindList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

const KeybindItem = styled.li`
    font-family: "Barlow-Regular", Helvetica;
    font-size: 14px;
    color: ${setColor.inputText};
    margin-bottom: 5px;
    padding: 5px 0;
`;
